import HBIcon from "@/components/HBIcon";
import { useThrottleFn } from "ahooks";
import { Button, Form } from "antd";
import classNames from "classnames";
import { useCallback, useRef, useState } from "react";
import { getMe, login } from "../../../services";
import { isEnter } from "../../../utils/keyBoard";
import HBInput from "../../HBInput";
import HBMessage from "../../HBMessage";
import styles from "../index.module.less";
import accountLocked from "../shared/accountLocked";
import Password from "../shared/password";
import rules from "../shared/rules";
import { ThirdLogin } from "../shared/third";
import UserAgreement from "../shared/userAgreement";

export default function Login({
  onOk,
  setType,
  initialTel = "",
  onThirdLogin,
  ...rest
}) {
  const loginFormRef = useRef(null);
  const [loginLoading, setLoading] = useState(false);

  // const onGoRegister = async () => {
  //   setType("register");
  // };

  const onGoReset = async () => {
    setType("reset");
  };

  const switchWechat = useCallback(() => {
    setType("wechat");
  }, [setType]);

  const { run: onLogin } = useThrottleFn(
    async () => {
      setLoading(true);
      try {
        const values = await loginFormRef.current.validateFields();
        const result = await login({
          ...values,
          email: values.email.trim(),
        });

        setLoading(false);
        // 当前登录成功会重定向到 lastboard接口
        // 登录失败【密码错误、手机号未注册】会重定向到 login接口

        // 账号冻结处理
        if (result.err === 403) {
          accountLocked(result);
          return;
        }

        if (result.err) {
          HBMessage.error(result.msg || "登录失败");
          return;
        }

        if (result.referer) {
          HBMessage.error("手机号/邮箱或者密码错误!");
          return;
        }
        const user = await getMe();

        if (!user.err) {
          onOk(user);
        } else {
          HBMessage.error(user.msg || "获取用户信息失败");
        }
      } catch (error) {
        setLoading(false);
      }
    },
    { wait: 300 }
  );

  return (
    <div {...rest} className={styles.login}>
      {/* <Logo />
      <div className={styles.title}>欢迎来到花瓣</div> */}
      <Form className={styles.form} ref={loginFormRef}>
        <Form.Item
          className={styles.item}
          name="email"
          rules={rules.telAndEmail}
          initialValue={initialTel}
        >
          <HBInput placeholder="手机号或邮箱" autofillCheck />
        </Form.Item>
        <Form.Item
          className={classNames([styles.item, styles.short])}
          name="password"
          rules={rules.password}
        >
          <Password
            placeholder="密码"
            autofillCheck
            onKeyDown={(e) => {
              if (isEnter(e)) {
                onLogin();
              }
            }}
          />
        </Form.Item>
      </Form>
      <div className={styles.forget}>
        <a onClick={onGoReset}>忘记密码？</a>
      </div>
      <Button
        className={styles.button}
        type="primary"
        onClick={onLogin}
        loading={loginLoading}
      >
        登录
      </Button>
      <div className={styles.other}>
        <div
          className={classNames([styles.thirdLoginItem, styles.wechat])}
          data-gd-click="button_click"
          data-button-name="微信登录注册"
          onClick={switchWechat}
          style={{
            marginRight: 12,
          }}
        >
          <HBIcon className={styles.icon} type="ic_wechat1" title="微信" />
        </div>
        <ThirdLogin onOk={onThirdLogin} />
      </div>

      <UserAgreement />
    </div>
  );
}
